import {
  SURVEY_ADD,
  SURVEY_EDIT,
  SURVEY_LIST_PATH,
  SURVEY_PREVIEW,
  SURVEY_VIEW,
  ROOT,
  NO_PERMISSION_PATH,
} from 'constant/path';
import React, { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useAppSelector } from 'reducers/models';
import { roleConstant, transformDataRole } from 'role/constant';
import useTitle from 'hooks/useTitle';
import { SideBarTitle } from 'utils/helperFunctions';

interface ISurveyListProtectedWrapperProps {
  children: React.ReactNode;
}

const SurveyListProtectedWrapper: React.FC<ISurveyListProtectedWrapperProps> = ({ children }) => {
  useTitle(SideBarTitle.SURVEYS);
  const location = useLocation();
  const navigate = useNavigate();
  const isLoading = useAppSelector((state) => state.auth.isLoading);
  const surveyAuthorization = useAppSelector((state) => state.auth.surveyAuthorization);
  const surveyListRole = useMemo(
    () => transformDataRole(surveyAuthorization),
    [JSON.stringify(surveyAuthorization)]
  );

  const handleNavigate = () => {
    const currentPathName = location.pathname;
    if (isLoading) {
      return;
    }
    if (surveyListRole[roleConstant.all]) {
      return;
    }
    if (currentPathName.includes(SURVEY_ADD)) {
      if (surveyListRole[roleConstant.addSurvey] || surveyListRole[roleConstant.copySurvey]) {
        return;
      }
      navigate(`${ROOT}${NO_PERMISSION_PATH}`);
    }
    if (currentPathName.includes(SURVEY_EDIT) && !surveyListRole[roleConstant.edit]) {
      navigate(`${ROOT}${NO_PERMISSION_PATH}`);
      return;
    }
    if (currentPathName.includes(SURVEY_VIEW) && !surveyListRole[roleConstant.view]) {
      navigate(`${ROOT}${NO_PERMISSION_PATH}`);
      return;
    }
    if (currentPathName.includes(SURVEY_PREVIEW) && !surveyListRole[roleConstant.view]) {
      navigate(`${ROOT}${NO_PERMISSION_PATH}`);
      return;
    }
  };
  useEffect(() => {
    handleNavigate();
  }, [location.pathname, isLoading]);

  return <>{children}</>;
};
export default SurveyListProtectedWrapper;
